// 图片资源配置文件
// 将所有图片链接集中管理，方便后续配置修改

// 顶部工具栏社交媒体图标
export const socialMediaIcons = {
  facebook: '#',
  twitter: '#',
  instagram: '#',
  linkedin: '#'
}

// 首页图片资源
export const homeImages = {
  // 英雄区域背景图
  heroBg:
    'https://ai-public.mastergo.com/ai/img_res/31bf603c28707b46e6df1dd81a37dbf5.jpg',

  // 产品分类图片
  productCategories: {
    ecommerce:
      'https://ai-public.mastergo.com/ai/img_res/ad609f04af07d0ebf183ffe78194c0ef.jpg',
    brandCustom:
      'https://ai-public.mastergo.com/ai/img_res/fe8e8d2ea40cce3638420427e09e0560.jpg'
  },

  // 品牌信任区域
  brandLogos: {
    brand1:
      'https://ai-public.mastergo.com/ai/img_res/78ee71f324e9e219f0b70f8d16a6eeac.jpg',
    brand2:
      'https://ai-public.mastergo.com/ai/img_res/7b5e80919a97ce3a39af7aa1f3f891be.jpg',
    brand3:
      'https://ai-public.mastergo.com/ai/img_res/b5dba9b5d7a17f6c0f7a7cab5b981b66.jpg',
    brand4:
      'https://ai-public.mastergo.com/ai/img_res/526e7db39670464d9087aa3d3af41773.jpg'
  },

  // 可持续包装图片
  sustainablePackaging: {
    main: 'https://ai-public.mastergo.com/ai/img_res/31bf603c28707b46e6df1dd81a37dbf5.jpg'
  }
}

// 其他页面图片资源可以按需添加
